<template>
  <g>
    <polygon
      v-if="isTop"
      class="topPolygon"
      :points="topPolygon"
    />
    <polygon
      v-else
      class="bottomPolygon"
      :points="bottomPolygon"
    />
    <polygon
      class="rightPolygon"
      :points="rightPolygon"
    />
  </g>
</template>

<script>
	export default {
		name: 'Link',
		props: {
			x: Number,
			y: Number,
			deltaY: {
				type: Number,
				default: 0,
			},
			height: {
				type: Number,
				default: 2.6,
			},
			rackOffset: Object,
			depthOffset: Object,
		},
		computed: {
			isTop() {
				return (this.deltaY < 20);
			},
			topPolygon() {
				return `${this.x + this.rackOffset.x + this.rackOffset.width},${this.y - this.rackOffset.y}
						${this.x - this.rackOffset.x + this.rackOffset.width + this.depthOffset.x},${this.y + this.rackOffset.y - this.depthOffset.y + this.deltaY}
						${this.x - this.rackOffset.x + this.depthOffset.x},${this.y + this.rackOffset.y - this.depthOffset.y + this.deltaY}
						${this.x + this.rackOffset.x},${this.y - this.rackOffset.y}`;
			},
			bottomPolygon() {
				return `${this.x + this.rackOffset.x + this.rackOffset.width},${this.y - this.rackOffset.y + this.height}
						${this.x - this.rackOffset.x + this.rackOffset.width + this.depthOffset.x},${this.y + this.rackOffset.y - this.depthOffset.y + this.deltaY + this.height}
						${this.x - this.rackOffset.x + this.depthOffset.x},${this.y + this.rackOffset.y - this.depthOffset.y + this.deltaY + this.height}
						${this.x + this.rackOffset.x},${this.y - this.rackOffset.y + this.height}`;
			},
			rightPolygon() {
				return `${this.x + this.rackOffset.x + this.rackOffset.width},${this.y - this.rackOffset.y}
						${this.x - this.rackOffset.x + this.rackOffset.width + this.depthOffset.x},${this.y + this.rackOffset.y - this.depthOffset.y + this.deltaY}
						${this.x - this.rackOffset.x + this.rackOffset.width + this.depthOffset.x},${this.y + this.rackOffset.y - this.depthOffset.y + this.deltaY + this.height}
						${this.x + this.rackOffset.x + this.rackOffset.width},${this.y - this.rackOffset.y + this.height}`;
			},
		},
	};
</script>

<style scoped>
	.topPolygon {
		fill: #DCDDDE;
	}
	.bottomPolygon {
		fill: #D4D4D4;
	}
	.rightPolygon {
		fill: #AFB1B4;
	}
</style>